import { Amount } from 'uom';

export interface AmountObject {
  value: number;
  uom: string;
}

export interface ReduceOptionInterface {
  operation: Function;
  initialValue: Amount.Amount<any>;
  dataset?: { value: string; uom: string };
  defaultUom?: string;
}
